import Footer from "../../components/Footer";

const FooterContainer = ({ bgColor }) => {
  return <Footer bgColor={bgColor} />;
};

export default FooterContainer;
